import React, { useEffect } from "react";
import AppRouter from "./route";
import { Provider, useSelector, useDispatch } from "react-redux";
import { store, RootState } from "./store/index";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  GlobalToastManager,
  NavigationToastHandler,
} from "@ippon/shared-components";
import AIChatButton from "@/components/AIChatbot/AIChatButton";
import { removeSecureCookie } from "@/utils/authUtils";
import { removeToast } from "@/store/toastSlice";
import { useGlobalToast } from "@/hooks/useGlobalToast";
import { useNavigate } from "react-router-dom";
// Removed app-specific MUI theme wrapper; using SharedComponentsThemeProvider in main.tsx

const ToastProviders: React.FC = () => {
  const dispatch = useDispatch();
  const toasts = useSelector(
    (state: RootState) => (state as any).toast?.toasts || []
  );
  const navigate = useNavigate();
  const { showToast } = useGlobalToast();

  return (
    <>
      <NavigationToastHandler showToast={showToast} />
      <GlobalToastManager
        toasts={toasts}
        onRemoveToast={(id) => dispatch(removeToast(id) as any)}
        onLinkClick={(linkId) => navigate(`/setting/account/${linkId}`)}
      />
    </>
  );
};

const App: React.FC = () => {
  useEffect(() => {
    // 外部サイトからの遷移を検出してサービスキャッシュをクリア
    const referrer = document.referrer;
    if (referrer) {
      try {
        const referrerUrl = new URL(referrer);
        const currentHost = window.location.host;

        // referrerのホストが現在のホストと異なる場合は外部からの遷移
        if (referrerUrl.host !== currentHost) {
          removeSecureCookie("my_use_service");
        }
      } catch (error) {
        // URL解析エラーは無視
        console.debug("Failed to parse referrer URL:", error);
      }
    }
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Provider store={store}>
        <AppRouter />
        <ToastProviders />
      </Provider>
    </LocalizationProvider>
  );
};

export default App;
